export var setInitialPasswordButtonLinkConstants = {
    ANDROID_APP_LINK: 'https://play.google.com/store/apps/details?id=com.lgi.upcch',
    IOS_APP_LINK: 'https://apps.apple.com/ch/app/upc-tv-schweiz/id1292688012',
    TV_AUTH_SETUP: 'https://www.sunrise.ch/en/support/tv/sunrise-tv-app/tv-app',
    EN_SETUP: 'https://www.sunrise.ch/en/support/tv/sunrise-tv-app/tv-app-without-box',
    FR_SETUP: 'https://www.sunrise.ch/fr/support/tv/sunrise-tv-app/app-tv-sans-box',
    IT_SETUP: 'https://www.sunrise.ch/it/supporto/tv/sunrise-tv-app/app-tv-senza-box',
    DE_SETUP: 'https://www.sunrise.ch/de/support/tv/sunrise-tv-app/tv-app-ohne-box',
    DE_SUPPORT_LINK: 'https://www.sunrise.ch/de/support/upc-to-sunrise-win-tv-app',
    FR_SUPPORT_LINK: 'https://www.sunrise.ch/fr/support/upc-to-sunrise-win-tv-app',
    IT_SUPPORT_LINK: 'https://www.sunrise.ch/it/support/upc-to-sunrise-win-tv-app',
    EN_SUPPORT_LINK: 'https://www.sunrise.ch/en/support/upc-to-sunrise-win-tv-app',
    EN: 'EN' || 'en',
    FR: 'FR' || 'fr',
    IT: 'IT' || 'it'
};
